import React, { PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as authActions from '../auth/auth.actions';
import { push } from 'react-router-redux';

const sessionType = 'setup';

const tokenUrl = process.env.ETO_TOKEN_URL;

const etoTokenSubscriptions = [];
function broadcastEtoToken(token) {
  etoTokenSubscriptions.forEach(s => s(token));
}

window.addEventListener('message', e => {
  const data = safeParseJson(e.data);
  if (data && data.type === 'eto-token') {
    broadcastEtoToken(data);
  }
});

function safeParseJson(str) {
  try {
    return JSON.parse(str + '');
  } catch(ex) {
    return null;
  }
}

export function requireEtoAuthentication(Component, opts = {}) {
  class AuthenticatedComponent extends React.Component {
    processNewToken(data) {
      const { authActions } = this.props;
      authActions.createEtoSession(data.enterpriseGuid, data.token)
        .catch(ex => { });
    }

    componentWillMount() {
      etoTokenSubscriptions.push(token => this.processNewToken(token));
      this.verifyAuthentication(this.props);
    }

    componentWillReceiveProps(nextProps) {
      this.verifyAuthentication(nextProps);
    }

    verifyAuthentication(props) {
      const { auth, authActions } = props;
      const { isAuthenticated, currentSession, authToken, isFetching, err } = auth;

      if(!isAuthenticated && authToken && !isFetching && err === null) {
        return authActions.getCurrentSessionFromSecureToken(authToken)
          .catch(err => { });
      }

      if(currentSession && currentSession.type !== sessionType) {
        return authActions.invalidateCurrentSession();
      }

      // we've made it this far.  Verify that the token is still good before attempting
      // whatever is next.  If we can detect that the token is no longer valid, we need to invalidate
      // the current session.  Only attempt the validity check for non-empty guids.

      if(isAuthenticated && currentSession && currentSession.type === sessionType &&
          authToken && authToken !== '00000000-0000-0000-0000-000000000000') {
        authActions.verifySession(authToken);
      }

    }

    redirectToLogin() {
      const { authActions, routing } = this.props;
      const { pathname } = routing.locationBeforeTransitions;
      authActions.redirectToEtoLogin(pathname);
    }

    loadingMessage(message, isError) {
      const { level, glyph } = isError
        ? { level: 'error', glyph: 'remove-sign' }
        : { level: 'loading', glyph: 'refresh' };

      return (
        <div className={`session-loader session-loader-${level}`}>
          <div className="session-loader-message">
            <span className={`glyphicon glyphicon-${glyph}`} />
            { message }
          </div>
        </div>
      )
    }

    render() {
      const { err, isAuthenticated, isFetching, currentSession, authToken } = this.props.auth;

      if (err && err.errorCode !== 'unauthenticated') {
        return this.loadingMessage(err.errorMessage || 'There was an error retrieving your session', true);
      }

      if (isFetching && authToken) {
        return this.loadingMessage('Loading Session...')
      }

      if (isFetching) {
        return this.loadingMessage('Creating Session...')
      }

      if (isAuthenticated && currentSession && currentSession.type !== sessionType) {
        return this.loadingMessage('Your session is of the wrong type.', true);
      }

      if (!isAuthenticated) {
        return (
          <div>
            <iframe id="EtoFrame" src={tokenUrl}></iframe>
            {this.loadingMessage('Waiting on session transfer from ETO...')}
          </div>
        )
      }

      return (
        <div>
          <Component {...this.props} />
        </div>
      );
    }
  }

  AuthenticatedComponent.propTypes = {
    auth: PropTypes.any.isRequired,
    authActions: PropTypes.any.isRequired,
    routing: PropTypes.any.isRequired,
    opts: PropTypes.any.isRequired
  }

  function mapStateToProps({ auth, routing }) {
    return {
      auth,
      routing,
      opts
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      authActions: bindActionCreators(authActions, dispatch),
      redirect: bindActionCreators(push, dispatch)
    };
  }

  return connect(mapStateToProps, mapDispatchToProps)(AuthenticatedComponent)
}



// WEBPACK FOOTER //
// src/auth/require-eto-authentication.js